function observeShadowDOMForm() {
  const observer = new MutationObserver((mutations, obs) => {
    const shopifyFormsEmbed = document.querySelector('shopify-forms-embed#app-embed');
    
    if (shopifyFormsEmbed?.shadowRoot) {
      const form = shopifyFormsEmbed.shadowRoot.querySelector('form[data-testid="form"]');
      
      if (form) {
        obs.disconnect(); // Stop observe
        
        // Setup submit listener
        form.addEventListener('submit', function(event) {
          event.preventDefault();
          
          setTimeout(() => {
            const hasError = 
              form.querySelector('input[aria-invalid="true"]') !== null ||
              form.querySelector('._withError_1mxsl_17') !== null;
            
            if (!hasError) {
              const data = {
                name: form.querySelector('#first_name')?.value || '',
                email: form.querySelector('#email')?.value || ''
              };
              
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'form_submission_schools',
                ecommerce: {
                    custom_data: data
                },
              });
            } 
          }, 150);
        });
      }
    }
  });
  
  // Observe whole document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  setTimeout(() => {
    observer.disconnect();
  }, 10000);
}

observeShadowDOMForm();